import { useContext, useEffect, useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Card, Modal, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import DownloadIocon from "assets/images/download-icon.svg";
import UploadIocon from "assets/images/file-icon.png";
import WatchIocon from "assets/images/Watch-icon.png";
import goto from "assets/images/goto.svg";

import BlackPinIcon from "assets/images/inspector-pin-icon.svg";

import storage from "../../../helpers/storage";
import Loader from "../../../components/common/Loader";
import phoneMask from "../../../helpers/phoneMask";
import { nameBasedProtectedRoutes } from "../../../router/protected";
import { getInspectorSrDetails } from "../../../services/inspectionRequest";
import { toast } from "react-toastify";
import { MESSAGES, VALIDATION } from "../../../constants/messages";
import moment from "moment";
import InspectionArrow from "assets/images/inspection-arrow.svg";
import { GOOGLE_MAP_URL } from "../../../constants/paths";
import ImageTag from "../../../components/common/ImageTag";
import { Formik } from "formik";
import InputText from "components/common/InputText";
import {
  TravelInformationExpensesSchema,
  TravelInformationSchema,
  TravelNotesSchema,
} from "validations/InspectionRequest";
import InputTextArea from "components/common/TextArea";
import MatTimePicker from "components/common/MatTimePicker";
import {
  addTravelInformation,
  deleteTravelInformationAPI,
  updateTravelAndInspectionHoursAPI,
  updateTravelInformation,
  updateTravelInformationExpensesAPI,
  updateTravelNotes,
} from "services/inspectorRequest";
import {
  DBTravelInformationInterface,
  TravelInformationInterface,
  MachineInterface,
} from "interfaces/travelInformationInterface";

import travelInfoEdit from "assets/images/Edit-icon.svg";
import travelInfoDelete from "assets/images/Delete-icon.svg";
import {
  datetimeFormats,
  inspectionStatusGridClassAndLabel,
  inspectionStatusWithoutKey,
} from "../../../constants/constants";
import {
  calculateTimeDifference,
  changeToHoursAndMinutes,
} from "helpers/common";
import PhotoGalleryImg from "assets/images/photo-gallery-img1.png";
import { Scrollbars } from "react-custom-scrollbars";
import { PhotoGallery } from "./PhotoGallery";
import iconCameraGray from "assets/images/icon-camera-gray.svg";
import iconCameraBlue from "assets/images/icon-camera-blue.svg";
import { MyContext } from "MyProvider";
import InputSelectMultipleAutocomplete from "components/common/InputSelectMultipleAutocomplete";
import AddNewMachine from "./addNewMachine";
import MachineHistory from "./MachineHistory";

export const InspectionDetail = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadForm, setLoadForm] = useState(false);
  const [show, setShow] = useState(false);
  const [showImages, setShowImages] = useState(false);
  const [showTravelNotes, setShowTravelNotes] = useState(false);
  const [machineId, setMachineId] = useState(null);
  const loaction = useLocation();
  const [showMachine, setShowMachine] = useState(false);

  const [totalTravelTime, setTotalTravelTime] = useState("");
  const [totalInspectionTime, setTotalInspectionTime] = useState("");
  let { id } = useParams();
  const [inspectionData, setInspectionData] = useState<any>([]);
  const [inspectionType, setInspectionType] = useState([]);
  const [inspectionMachines, setInspectionMachines] = useState<
    MachineInterface[]
  >([]);
  const [isMutation, setIsMutation] = useState(false);
  const initialTravelInfo = {
    id: null,
    inspection_id: id ? id : null,
    travel_start: null,
    travel_stop: null,
    inspection_start: null,
    inspection_stop: null,
    description: "",
  };
  const [travelInformation, setTravelInformation] =
    useState<TravelInformationInterface>(initialTravelInfo);
  const [allTravelInformation, setAllTravelInformation] = useState<
    DBTravelInformationInterface[]
  >([]);
  const [oldExpenses, setOldExpenses] = useState<{
    id: number | null;
    tolls_cost: number | null;
    meals_cost: number | null;
    lodging_cost: number | null;
    mileage_cost: number | null;
    misc_cost: number | null;
    inspection_id: string | null;
  }>();

  let [jobTime, setJobTime] = useState<Date | null>();
  let [userFullAddress, setUserFullAddress] = useState<String | null>();
  let [fullAddress, setFullAddress] = useState<String | null>();
  const [travelExpensesId, setTravelExpensesId] = useState<number | null>(null);
  const { setRedirectUrlState } = useContext(MyContext);

  useEffect(() => {
    if (storage.getToken() != null) {
      getSrInspectionData();
    }
  }, [isMutation]);

  useEffect(() => {
    if (storage.getToken() != null) {
      setRedirectUrlState(loaction.pathname);
      if (loaction.state) {
        setShow(true);
      }
    }
  }, []);

  const getSrInspectionData = async () => {
    setLoading(true);
    if (id) {
      getInspectorSrDetails({ id })
        .then(async (response) => {
          setInspectionData(response?.data);
          setAllTravelInformation(response?.data?.travel_informations);
          setInspectionType(response?.inspectionType);
          const resInspectionTypeOptions = response?.inspectionType;
          const criteriaOptionsList = response?.criteriaOptions;
          if (response?.data?.job_time) {
            setJobTime(new Date("2013-05-16 " + response?.data?.job_time));
          }
          const machines = response?.data?.Inspection_machines;
          if (response?.data?.travel_information_expense) {
            setTravelExpensesId(response?.data?.travel_information_expense?.id);
          }
          const expenses = {
            id: response?.data?.travel_information_expense?.id
              ? response?.data?.travel_information_expense?.id
              : null,
            tolls_cost: response?.data?.travel_information_expense?.tolls_cost
              ? response?.data?.travel_information_expense?.tolls_cost
              : null,
            meals_cost: response?.data?.travel_information_expense?.meals_cost
              ? response?.data?.travel_information_expense?.meals_cost
              : null,
            lodging_cost: response?.data?.travel_information_expense
              ?.lodging_cost
              ? response?.data?.travel_information_expense?.lodging_cost
              : null,
            mileage_cost: response?.data?.travel_information_expense
              ?.mileage_cost
              ? response?.data?.travel_information_expense?.mileage_cost
              : null,
            misc_cost: response?.data?.travel_information_expense?.misc_cost
              ? response?.data?.travel_information_expense?.misc_cost
              : null,
            inspection_id: id ? id : null,
          };
          setOldExpenses(expenses);
          const userCity = response?.data?.user?.city
            ? ", " + response?.data?.user?.city
            : "";
          const userState = response?.data?.user?.state
            ? ", " + response?.data?.user?.state?.title
            : "";
          const userZip = response?.data?.user?.zipcode
            ? " " + response?.data?.user?.zipcode
            : "";
          const userFullAddress =
            response?.data?.user?.address + userCity + userState + userZip;
          setUserFullAddress(userFullAddress);
          const city = response?.data?.city ? ", " + response?.data?.city : "";
          const state = response?.data?.state
            ? ", " + response?.data?.state?.title
            : "";
          const zip = response?.data?.zipcode
            ? " " + response?.data?.zipcode
            : "";
          const fullAddress = response?.data.address + city + state + zip;
          setFullAddress(fullAddress);
          const newData = await Promise.all(
            machines.map(
              (obj: { inspection_type: string; criteria: string }) => {
                const inspectionType = obj?.inspection_type
                  ? resInspectionTypeOptions.find(
                      (type: { key: string }) =>
                        obj?.inspection_type == type.key
                    )
                  : "";
                const criteria = obj?.criteria
                  ? criteriaOptionsList.find(
                      (type: { key: string }) => obj?.criteria == type.key
                    )
                  : "";
                const updateMachine = {
                  ...obj,
                  inspection_type: inspectionType,
                  criteria: criteria,
                };
                return updateMachine;
              }
            )
          );

          setInspectionMachines(newData);

          setLoading(false);
          setLoadForm(true);
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      toast.error(MESSAGES.noRecordFound);
    }
  };

  const travelInformationSubmitForm = (values: TravelInformationInterface) => {
    setLoading(true);
    const formdata = {
      id: values.id,
      inspection: id ? id : null,
      description: values.description,
      travel_start: moment(values.travel_start).format("H:mm:ss"),
      travel_stop: moment(values.travel_stop).format("H:mm:ss"),
      inspection_start: moment(values.inspection_start).format("H:mm:ss"),
      inspection_stop: moment(values.inspection_stop).format("H:mm:ss"),
    };

    if (values.id) {
      updateTravelInformation(formdata)
        .then((response) => {
          const index = allTravelInformation.findIndex(
            (item: { id: number | null }) => item.id === values.id
          );
          let updatedInfo = [...allTravelInformation];
          updatedInfo[index] = {
            ...updatedInfo[index],
            travel_start: formdata.travel_start,
            travel_stop: formdata.travel_stop,
            inspection_start: formdata.inspection_start,
            inspection_stop: formdata.inspection_stop,
            description: formdata.description,
          };
          setAllTravelInformation(updatedInfo);
          setLoading(false);
          toast.success(response?.data?.message);
          setShow(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error?.response?.data?.message);
        });
    } else {
      addTravelInformation(formdata)
        .then((response) => {
          const newData = {
            id: response.data.data.id,
            inspection_id: response.data.data.inspection_id,
            travel_start: response.data.data.travel_start,
            travel_stop: response.data.data.travel_stop,
            inspection_start: response.data.data.inspection_start,
            inspection_stop: response.data.data.inspection_stop,
            description: response.data.data.description,
          };
          const updatedInfo = [...allTravelInformation, newData];
          setAllTravelInformation(updatedInfo);
          toast.success(response?.data?.message);
          setLoading(false);
          setShow(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error?.response?.data?.message);
        });
    }
  };

  const handleSubmit = (
    values: {
      id: number;
      tolls_cost: number;
      meals_cost: number;
      lodging_cost: number;
      mileage_cost: number;
      misc_cost: number;
    },
    setFieldValue: any
  ) => {
    const expensesId = travelExpensesId ? travelExpensesId : null;
    const formData = {
      id: values.id ? values.id : expensesId,
      tolls_cost: values.tolls_cost ? values.tolls_cost : null,
      meals_cost: values.meals_cost ? values.meals_cost : null,
      lodging_cost: values.lodging_cost ? values.lodging_cost : null,
      mileage_cost: values.mileage_cost ? values.mileage_cost : null,
      misc_cost: values.misc_cost ? values.misc_cost : null,
      inspection_id: id ? id : null,
    };

    const areEqual = JSON.stringify(oldExpenses) === JSON.stringify(formData);
    if (!areEqual) {
      setLoading(true);
      setOldExpenses(formData);
      updateTravelInformationExpensesAPI(formData)
        .then((response) => {
          toast.success(response?.data?.message);
          if (response?.data?.data?.id)
            setTravelExpensesId(response?.data?.data?.id);
          setFieldValue("id", response?.data?.data?.id);

          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error?.response?.data?.message);
        });
    }
  };
  const [travelInfoTitle, setTravelInfoTitle] = useState<string>(
    "Add Travel Information"
  );
  const addNewTravelInformation = () => {
    setTravelInformation(initialTravelInfo);
    setTravelInfoTitle("Add Travel Information");
    setShow(true);
  };
  const handleModalClose = () => {
    setShow(false);
  };

  const handleShowMachineClose = () => {
    setShowMachine(false);
  };

  const handleShowMachineShow = () => {
    setShowMachine(true);
  };

  const editTravelInformation = async (infoId: number) => {
    setTravelInfoTitle("Edit Travel Information");
    let getInfoData = allTravelInformation.find(
      (type: { id: number | null }) => infoId == type.id
    );
    if (getInfoData) {
      const updateInfoData = {
        ...getInfoData,
        travel_start: moment(
          new Date("2013-05-16 " + getInfoData.travel_start)
        ),
        travel_stop: moment(new Date("2013-05-16 " + getInfoData.travel_stop)),
        inspection_stop: moment(
          new Date("2013-05-16 " + getInfoData.inspection_stop)
        ),
        inspection_start: moment(
          new Date("2013-05-16 " + getInfoData.inspection_start)
        ),
      };

      setTravelInformation(updateInfoData);
      setShow(true);
    } else {
      toast.error("Something went wrong");
    }
  };

  const deleteTravelInformation = async (id: number) => {
    setLoading(true);
    deleteTravelInformationAPI({ id })
      .then((response) => {
        const delTravelInfo = allTravelInformation.filter(
          (item: { id: number }) => item.id !== id
        );
        setAllTravelInformation(delTravelInfo);
        setLoading(false);
        toast.success(response?.data?.message);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  const openMachine = (model_id: String, inspectionMachine: any) => {
    if (!inspectionData?.inspector?.signature) {
      toast.error("Please make sure your signature is updated.");
      return false;
    }
    navigate(nameBasedProtectedRoutes.machineDetail.path, {
      state: {
        model_id: model_id,
        inspectionData: inspectionData,
        inspectionType: inspectionType,
        inspectionMachine: inspectionMachine,
      },
    });
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  const [timeChange, setTimeChange] = useState(false);
  useEffect(() => {
    timeCalculation();
  }, [allTravelInformation]);

  const timeCalculation = async () => {
    let travelTimeFirst = 0;
    let travelTimeSecond = 0;
    let inspectionTime = 0;
    allTravelInformation.forEach(function (travel) {
      travelTimeFirst += calculateTimeDifference(
        travel.travel_start,
        travel.inspection_start
      );
      travelTimeSecond += calculateTimeDifference(
        travel.inspection_stop,
        travel.travel_stop
      );
      inspectionTime += calculateTimeDifference(
        travel.inspection_start,
        travel.inspection_stop
      );
    });

    const sumTravelTime = await changeToHoursAndMinutes(
      travelTimeFirst + travelTimeSecond
    );
    const sumInspectionTime = await changeToHoursAndMinutes(inspectionTime);
    setTotalTravelTime(sumTravelTime.hours + "." + sumTravelTime.minutes);
    setTotalInspectionTime(
      sumInspectionTime.hours + "." + sumInspectionTime.minutes
    );
    setTimeChange(!timeChange);
  };

  useEffect(() => {
    updateTravelAndInspectionHours();
  }, [timeChange]);

  const updateTravelAndInspectionHours = () => {
    const formData = {
      id: travelExpensesId ? travelExpensesId : null,
      inspection_id: id ? id : null,
      travel_time: totalTravelTime,
      inspection_time: totalInspectionTime,
    };
    updateTravelAndInspectionHoursAPI(formData)
      .then((response) => {
        if (response?.data?.data?.id)
          setTravelExpensesId(response?.data?.data?.id);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };

  const handleImageModalClose = () => {
    setShowImages(false);
  };

  const handleTravelNotesModalClose = () => {
    setShowTravelNotes(false);
  };

  const uploadMachineImages = (id) => {
    setMachineId(id);
    setShowImages(true);
  };

  const travelNotesSubmitForm = (values: { travel_notes: string }) => {
    setLoading(true);
    const formdata = {
      inspection: id,
      travel_notes: values.travel_notes,
    };

    updateTravelNotes(formdata)
      .then((response) => {
        setLoading(false);
        setIsMutation(!isMutation);
        toast.success(response?.data?.message);
        setShow(false);
        setShowTravelNotes(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };

  return (
    <>
      <section className="profile-main pt-4 inspector-bg">
        <Container className="">
          <Row>
            <Col md={12} lg={12}>
              <h1 className="fs-16  mb-3 mt-2">
                <ImageTag
                  role="button"
                  onClick={() =>
                    navigate(nameBasedProtectedRoutes.iuserDashboard.path)
                  }
                  src={InspectionArrow}
                  className="inspection-arrow"
                />
                <span className="fw-bold">
                  {" "}
                  SR No. - {inspectionData?.sr_number}
                </span>
              </h1>
            </Col>
          </Row>
          {showMachine && (
            <AddNewMachine
              showMachine={showMachine}
              handleShowMachineClose={handleShowMachineClose}
              inspectionType={inspectionType}
              user_id={inspectionData?.user?.id}
              inspection_id={inspectionData.id}
              setIsMutation={setIsMutation}
            />
          )}
          <Form>
            <Row>
              <Col className="inspector-tab-p-0" md={12} lg={12}>
                <Card className="border-0 mb-3">
                  <Card.Body className="br-10 p-4">
                    <h2 className="fs-20 fw-bold ls-2 border-left-6">
                      CUSTOMER INFORMATION
                    </h2>

                    <Row className="mt-3">
                      <Col md={12} lg={12}>
                        <Row>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Customer Name
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {inspectionData?.user?.full_name}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Customer #
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {inspectionData?.user?.customer_number}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Company Name
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {inspectionData?.user?.company_name}
                              </Form.Text>
                            </Form.Group>
                          </Col>

                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Email
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {inspectionData?.user?.email}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Phone
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {inspectionData?.user?.phone_no
                                  ? phoneMask(inspectionData?.user?.phone_no)
                                  : "-"}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Cell No.
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {inspectionData?.user?.cell_no
                                  ? phoneMask(inspectionData?.user?.cell_no)
                                  : "-"}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Address
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {userFullAddress}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                <Card className="border-0 mb-3">
                  <Card.Body className="br-10 p-4">
                    <Row className="">
                      <Col md={12} lg={12}>
                        <h2 className="fs-20 fw-bold ls-2 border-left-6 mb-3">
                          JOB INFORMATION
                        </h2>
                        <Row>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Address
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                <Link
                                  target="_blank"
                                  to={`${GOOGLE_MAP_URL}${fullAddress}`}
                                >
                                  {fullAddress}
                                </Link>
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Job Contact
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {inspectionData?.job_contact_no}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Phone
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {inspectionData?.phone_no
                                  ? phoneMask(inspectionData?.phone_no)
                                  : "-"}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Job Date
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {inspectionData?.inspection_date
                                  ? moment(
                                      inspectionData?.inspection_date
                                    ).format(datetimeFormats.separatedDate)
                                  : "-"}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                          <Col md={4} lg={4}>
                            <Form.Group
                              className="mb-3"
                              controlId="formBasicEmail"
                            >
                              <Form.Label className="fs-13 fw-bold text-default mb-0">
                                Job Time
                              </Form.Label>
                              <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                {jobTime
                                  ? moment(jobTime).format(
                                      datetimeFormats.timeIn12HourFormat
                                    )
                                  : "-"}
                              </Form.Text>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={4} lg={3}>
                        <Card className="card-bg card-border d-none">
                          <Card.Body>
                            <Card.Title className="fs-16 fw-bold text-default ls-16">
                              INVOICE DETAILS{" "}
                              <span
                                className="float-end"
                                style={{ cursor: "pointer" }}
                              >
                                <ImageTag src={DownloadIocon} />
                              </span>
                            </Card.Title>
                            <Row>
                              <Col md={6} lg={6}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="formBasicEmail"
                                >
                                  <Form.Label className="fs-13 fw-bold text-default mb-0">
                                    Date
                                  </Form.Label>
                                  <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                    12-10-2022
                                  </Form.Text>
                                </Form.Group>
                              </Col>
                              <Col md={6} lg={6}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="formBasicEmail"
                                >
                                  <Form.Label className="fs-13 fw-bold text-default mb-0">
                                    Number
                                  </Form.Label>
                                  <Form.Text className="d-block form-text fs-15 mt-0 text-default w-100">
                                    SR-2212520
                                  </Form.Text>
                                </Form.Group>
                              </Col>
                              <Col md={12} lg={12}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="formBasicEmail"
                                >
                                  <Form.Label className="fs-13 fw-bold text-default mb-0">
                                    Amount
                                  </Form.Label>
                                  <Form.Text className="d-block form-text fs-16 fw-bold mt-0 text-default w-100">
                                    $1272.50
                                  </Form.Text>
                                </Form.Group>
                              </Col>
                              <Col md={12} lg={12}>
                                <div className="text-center bg-ligt-green text-green fw-bold br-5 p-1">
                                  {" "}
                                  <i className="fas fa-check-circle fs-13"></i>{" "}
                                  Paid
                                </div>
                                <div className="text-center bg-light-red text-red fw-bold br-5 p-1">
                                  {" "}
                                  <i className="fas fa-exclamation-circle fs-13"></i>{" "}
                                  32 days overdue
                                </div>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Card className="border-0 mb-3">
                  <Card.Header className="border-0 bg-default bg-theme black-color fs-20 fw-bold ls-2 br-0 pe-4 ps-4 pt-1 pb-1 d-flex  justify-content-sm-between align-items-center ">
                    <div>MACHINE INFORMATION </div>

                    <Button
                      onClick={handleShowMachineShow}
                      className="add-new-btn"
                    >
                      Add Machine
                    </Button>
                  </Card.Header>
                  <div></div>
                  <Card.Body className="br-10 p-4">
                    <Row className="">
                      <Col md={12} lg={12}>
                        <div className="table-responsive">
                          <table className="table custom-table border-none-table table-striped inspector-detail-table-center">
                            <thead>
                              <tr>
                                <th>DEVICE ID</th>
                                <th className="insepection-list-make">MAKE</th>
                                <th>MODEL NO.</th>
                                <th>SERIAL NO.</th>
                                <th className="job-column">JOB LOCATION</th>
                                <th>INSPECTION TYPE</th>
                                <th>STATUS</th>
                                <th>ACTION</th>
                              </tr>
                            </thead>
                            <tbody>
                              {inspectionMachines?.map(
                                (machine: MachineInterface) => (
                                  <tr key={machine?.id}>
                                    <td className="insepection-list-device-id">
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip>
                                            {machine?.device_id}
                                          </Tooltip>
                                        }
                                      >
                                        <span className="text-nobreak">
                                          {machine?.device_id}
                                        </span>
                                      </OverlayTrigger>
                                    </td>
                                    <td className="insepection-list-make">
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip>{machine?.make}</Tooltip>
                                        }
                                      >
                                        <span className="text-nobreak">
                                          {machine?.make}
                                        </span>
                                      </OverlayTrigger>
                                    </td>

                                    <td
                                      role="button"
                                      className="insepection-list-make"
                                    >
                                      {/* <span role="button" className="text-link">
                                        {machine?.model_number}
                                      </span> */}
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip>
                                            {machine?.model_number}
                                          </Tooltip>
                                        }
                                      >
                                        <span className="text-nobreak text-link">
                                          {machine?.model_number}
                                        </span>
                                      </OverlayTrigger>
                                    </td>
                                    {/* <td>
                                      <Link
                                        to={""}
                                        className="text-decoration-none text-link"
                                      >
                                        <span
                                          role="button"
                                          className="text-link"
                                        >
                                          {machine?.model_number}
                                        </span>
                                      </Link>
                                    </td> */}
                                    <td className="insepection-list-serial-no">
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip>
                                            {machine?.serial_number}
                                          </Tooltip>
                                        }
                                      >
                                        <span className="text-nobreak">
                                          {machine?.serial_number}
                                        </span>
                                      </OverlayTrigger>
                                    </td>

                                    <td className="ps-10">
                                      <OverlayTrigger
                                        overlay={
                                          <Tooltip>
                                            {machine?.job_location}
                                          </Tooltip>
                                        }
                                      >
                                        <span className="d-inline-block">
                                          <Link
                                            target="_blank"
                                            to={`${GOOGLE_MAP_URL}${machine?.job_location}`}
                                          >
                                            {machine?.job_location}
                                          </Link>
                                        </span>
                                      </OverlayTrigger>
                                    </td>
                                    <td>
                                      {machine?.inspection_type
                                        ? machine?.inspection_type?.value
                                        : ""}
                                    </td>
                                    <td>
                                      {machine?.service_status ? (
                                        <span
                                          className={`${
                                            inspectionStatusGridClassAndLabel[
                                              machine?.service_status as keyof typeof inspectionStatusGridClassAndLabel
                                            ]["class"]
                                          } text-center br-5 p-1 pe-2 ps-2 fs-15 d-inline-block`}
                                        >
                                          {
                                            inspectionStatusGridClassAndLabel[
                                              machine?.service_status as keyof typeof inspectionStatusGridClassAndLabel
                                            ]["label"]
                                          }
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                      <span className="d-none text-center bg-ligt-green text-green br-5 p-1 pe-2 ps-2  fs-15 d-inline-block">
                                        Completed
                                      </span>
                                      <span className="d-none text-center bg-light-red text-red br-5 p-1 pe-2 ps-2  fs-15 d-inline-block">
                                        Deficient
                                      </span>
                                      <span className="d-none text-center bg-light-sky text-sky br-5 p-1 pe-2 ps-2  fs-15 d-inline-block">
                                        Docs In Process
                                      </span>
                                    </td>
                                    <td className="min-width100">
                                      <a
                                        href="javascript:void(0)"
                                        className="me-3"
                                      >
                                        <OverlayTrigger
                                          overlay={<Tooltip>Gallery</Tooltip>}
                                        >
                                          <ImageTag
                                            src={
                                              machine?.machine_images &&
                                              machine?.machine_images.length > 0
                                                ? iconCameraBlue
                                                : iconCameraGray
                                            }
                                            onClick={() =>
                                              uploadMachineImages(machine?.id)
                                            }
                                          />
                                        </OverlayTrigger>
                                      </a>
                                      {(machine.service_status ==
                                        inspectionStatusWithoutKey.Pending ||
                                        machine.service_status ==
                                          inspectionStatusWithoutKey.Inprogress ||
                                        machine.service_status ==
                                          inspectionStatusWithoutKey.Upcoming ||
                                        machine.service_status ==
                                          inspectionStatusWithoutKey.Docinprogress ||
                                          machine.service_status ==
                                            inspectionStatusWithoutKey.DefiReportWaiting ||
                                            machine.service_status ==
                                              inspectionStatusWithoutKey.DefiReportReceived
                                        
                                        ) && (
                                        <OverlayTrigger
                                          overlay={
                                            <Tooltip>Start Inspection</Tooltip>
                                          }
                                        >
                                          <span
                                            role="button"
                                            className="text-link me-3 "
                                            onClick={() => {
                                              openMachine(
                                                machine.model_number,
                                                machine
                                              );
                                            }}
                                          >
                                            <ImageTag src={goto} />
                                          </span>
                                        </OverlayTrigger>
                                      )}
                                      <a href="" className="me-3 d-none">
                                        <ImageTag src={UploadIocon} />
                                      </a>
                                      <a href="" className="d-none">
                                        <ImageTag src={WatchIocon} />
                                      </a>
                                      <MachineHistory
                                        machineId={machine?.machine_id}
                                        sr_number={machine?.serial_number}
                                      />
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Card className="border-0 mb-3">
                  <Card.Header className="border-0 bg-default bg-theme black-color fs-20 fw-bold ls-2 br-0 pe-4 ps-4 pt-1 pb-1 d-flex  justify-content-sm-between align-items-center ">
                    TRAVEL INFORMATION{" "}
                    <Button
                      onClick={addNewTravelInformation}
                      className="add-new-btn"
                    >
                      Add New
                    </Button>
                  </Card.Header>
                  <Card.Body className="br-10 p-4">
                    <Row className="">
                      <Col md={12} lg={12}>
                        <h2 className="fs-16 fw-bold ls-2 mb-3">
                          Travel Notes{" "}
                          <span
                            role="button"
                            className="me-3"
                            onClick={() => setShowTravelNotes(true)}
                          >
                            <ImageTag src={travelInfoEdit} />
                          </span>
                        </h2>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: inspectionData?.travel_notes?.replace(
                              /\n/g,
                              "<br>"
                            ),
                          }}
                        ></p>
                        <br />
                      </Col>
                      <Col md={12} lg={12}>
                        <div className="table-responsive">
                          <table className="table custom-table border-none-table table-striped">
                            <thead>
                              <tr>
                                <th>DESCRIPTION</th>
                                <th>TRAVEL START</th>
                                <th>INSPECTION START</th>
                                <th>INSPECTION STOP</th>
                                <th>TRAVEL STOP</th>
                                <th>ACTION</th>
                              </tr>
                            </thead>
                            <tbody>
                              {allTravelInformation.length > 0 ? (
                                allTravelInformation?.map(
                                  (
                                    travelInfo: DBTravelInformationInterface
                                  ) => (
                                    <tr key={travelInfo?.id}>
                                      <td>
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              travelInfo?.description?.replace(
                                                /\n/g,
                                                "<br>"
                                              ),
                                          }}
                                        ></p>
                                      </td>
                                      <td>
                                        {travelInfo?.travel_start
                                          ? travelInfo?.travel_start?.slice(
                                              0,
                                              -3
                                            )
                                          : ""}
                                      </td>
                                      <td>
                                        {travelInfo?.inspection_start
                                          ? travelInfo?.inspection_start?.slice(
                                              0,
                                              -3
                                            )
                                          : ""}
                                      </td>
                                      <td>
                                        {travelInfo?.inspection_stop
                                          ? travelInfo?.inspection_stop?.slice(
                                              0,
                                              -3
                                            )
                                          : ""}
                                      </td>
                                      <td>
                                        {travelInfo?.travel_stop
                                          ? travelInfo?.travel_stop?.slice(
                                              0,
                                              -3
                                            )
                                          : ""}
                                      </td>
                                      <td className="min-width100">
                                        <a
                                          href="javascript:void(0)"
                                          className="me-3"
                                          onClick={() =>
                                            editTravelInformation(
                                              travelInfo?.id
                                            )
                                          }
                                        >
                                          <ImageTag src={travelInfoEdit} />
                                        </a>
                                        <a
                                          href="javascript:void(0)"
                                          className=""
                                          onClick={() =>
                                            deleteTravelInformation(
                                              travelInfo?.id
                                            )
                                          }
                                        >
                                          <ImageTag src={travelInfoDelete} />
                                        </a>
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan={6} className="text-center">
                                    {VALIDATION.noRecords}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      {loadForm ? (
                        <Formik
                          validationSchema={TravelInformationExpensesSchema}
                          enableReinitialize={true}
                          initialValues={{
                            id: inspectionData?.travel_information_expense?.id
                              ? inspectionData?.travel_information_expense?.id
                              : null,
                            tolls_cost: inspectionData
                              ?.travel_information_expense?.tolls_cost
                              ? inspectionData?.travel_information_expense
                                  ?.tolls_cost
                              : "",
                            meals_cost: inspectionData
                              ?.travel_information_expense?.meals_cost
                              ? inspectionData?.travel_information_expense
                                  ?.meals_cost
                              : "",
                            lodging_cost: inspectionData
                              ?.travel_information_expense?.lodging_cost
                              ? inspectionData?.travel_information_expense
                                  ?.lodging_cost
                              : "",
                            mileage_cost: inspectionData
                              ?.travel_information_expense?.mileage_cost
                              ? inspectionData?.travel_information_expense
                                  ?.mileage_cost
                              : "",
                            misc_cost: inspectionData
                              ?.travel_information_expense?.misc_cost
                              ? inspectionData?.travel_information_expense
                                  ?.misc_cost
                              : "",
                          }}
                          onSubmit={handleSubmit}
                        >
                          {({
                            handleSubmit,
                            handleChange,
                            handleBlur,
                            values,
                            errors,
                            touched,
                            setFieldValue,
                            setFieldError,
                            setValues,
                          }) => (
                            <Form
                              className="pe-xl-3"
                              noValidate
                              onSubmit={handleSubmit}
                            >
                              <Row>
                                <input
                                  type="hidden"
                                  name="id"
                                  value={values.id}
                                />
                                {/* commit */}
                                <Col md={4} lg={4}>
                                  <InputText
                                    controlId="tolls_cost"
                                    label="Tolls ($)"
                                    placeholder="Tolls ($)"
                                    touched={touched.tolls_cost}
                                    handleBlur={handleSubmit}
                                    handleChange={handleChange}
                                    errorsField={errors.tolls_cost}
                                    value={values.tolls_cost}
                                    type="number"
                                    onKeyDown={handleKeyDown}
                                  />
                                </Col>
                                <Col md={4} lg={4}>
                                  <InputText
                                    controlId="meals_cost"
                                    label="Meals ($)"
                                    placeholder="Meals ($)"
                                    touched={touched.meals_cost}
                                    handleBlur={handleSubmit}
                                    handleChange={handleChange}
                                    errorsField={errors.meals_cost}
                                    value={values.meals_cost}
                                    type="number"
                                    onKeyDown={handleKeyDown}
                                  />
                                </Col>
                                <Col md={4} lg={4}>
                                  <InputText
                                    controlId="lodging_cost"
                                    label="Lodging ($)"
                                    placeholder="Lodging ($)"
                                    touched={touched.lodging_cost}
                                    handleBlur={handleSubmit}
                                    handleChange={handleChange}
                                    errorsField={errors.lodging_cost}
                                    value={values.lodging_cost}
                                    type="number"
                                    onKeyDown={handleKeyDown}
                                  />
                                </Col>
                                <Col md={4} lg={4}>
                                  <InputText
                                    controlId="mileage_cost"
                                    label="Mileage "
                                    placeholder="Mileage"
                                    touched={touched.mileage_cost}
                                    handleBlur={handleSubmit}
                                    handleChange={handleChange}
                                    errorsField={errors.mileage_cost}
                                    value={values.mileage_cost}
                                    type="number"
                                    onKeyDown={handleKeyDown}
                                  />
                                </Col>
                                <Col md={4} lg={4}>
                                  <InputText
                                    controlId="misc_cost"
                                    label="Misc. ($)"
                                    placeholder="Misc. ($)"
                                    touched={touched.misc_cost}
                                    handleBlur={handleSubmit}
                                    handleChange={handleChange}
                                    errorsField={errors.misc_cost}
                                    value={values.misc_cost}
                                    type="number"
                                    onKeyDown={handleKeyDown}
                                  />
                                </Col>
                              </Row>
                            </Form>
                          )}
                        </Formik>
                      ) : (
                        ""
                      )}
                    </Row>
                  </Card.Body>
                </Card>

                {inspectionData?.additional_notes ? (
                  <Card className="border-0 mb-3 bg-none">
                    <Card.Body className="br-10 p-4">
                      <h2 className="fs-20 fw-bold ls-2 border-left-6 mb-3">
                        ADDITIONAL NOTES
                      </h2>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: inspectionData?.additional_notes?.replace(
                            /\n/g,
                            "<br>"
                          ),
                        }}
                      ></p>
                    </Card.Body>
                  </Card>
                ) : (
                  ""
                )}
              </Col>
            </Row>
          </Form>
        </Container>
      </section>

      {/*Add Edit Travel Information*/}
      <Modal
        show={show}
        onHide={handleModalClose}
        centered
        dialogClassName="modal-350w add-travel-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fs-25 fw-bold">{travelInfoTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={TravelInformationSchema}
            initialValues={travelInformation}
            onSubmit={(values, actions) => {
              actions.setSubmitting(false);
              travelInformationSubmitForm(values);
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
            }) => (
              <Form className="text-start" noValidate onSubmit={handleSubmit}>
                <InputTextArea
                  controlId="description"
                  label="Description"
                  placeholder="Description"
                  touched={touched.description}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  errorsField={errors.description}
                  value={values.description}
                />
                <MatTimePicker
                  controlId="travel_start"
                  label="Travel start"
                  touched={touched.travel_start}
                  handleChange={(e: Date) => {
                    setFieldValue("travel_start", moment(e));
                  }}
                  errorsField={errors.travel_start}
                  value={values.travel_start}
                  handleBlur={handleBlur}
                />
                <Row>
                  <Col md={6}>
                    <MatTimePicker
                      controlId="inspection_start"
                      label="Inspection start"
                      touched={touched.inspection_start}
                      handleChange={(e: Date) => {
                        setFieldValue("inspection_start", moment(e));
                      }}
                      errorsField={errors.inspection_start}
                      value={values.inspection_start}
                      handleBlur={handleBlur}
                    />
                  </Col>
                  <Col md={6}>
                    <MatTimePicker
                      controlId="inspection_stop"
                      label="Inspection stop"
                      touched={touched.inspection_stop}
                      handleChange={(e: Date) => {
                        setFieldValue("inspection_stop", moment(e));
                      }}
                      errorsField={errors.inspection_stop}
                      value={values.inspection_stop}
                      handleBlur={handleBlur}
                    />
                  </Col>
                </Row>

                <MatTimePicker
                  controlId="travel_stop"
                  label="Travel stop"
                  touched={touched.travel_stop}
                  handleChange={(e: Date) => {
                    setFieldValue("travel_stop", moment(e));
                  }}
                  errorsField={errors.travel_stop}
                  value={values.travel_stop}
                  handleBlur={handleBlur}
                />

                <div className="d-flex justify-content-end mt-2">
                  <Button
                    variant="outline-secondary"
                    className="me-2 fs-15 fw-semibold text-black"
                    onClick={handleModalClose}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    className="fs-15 fw-semibold text-black"
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      {/*upload photo gallery*/}
      <Modal
        show={showImages}
        onHide={handleImageModalClose}
        centered
        dialogClassName="modal-400w"
      >
        <Modal.Header closeButton className="">
          <Modal.Title className="fs-18 fw-bold">Photo Gallery</Modal.Title>
        </Modal.Header>
        <Scrollbars className="photo-gallery-scroll" style={{ height: 420 }}>
          <PhotoGallery
            machine_id={machineId}
            setIsMutation={setIsMutation}
            isMutation={isMutation}
          />
        </Scrollbars>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <Button
              variant="outline-secondary"
              className="me-2 fs-15 fw-semibold text-black"
              onClick={handleImageModalClose}
            >
              Close
            </Button>
            <Button
              variant="primary"
              className="fs-15 fw-semibold text-black"
              type="button"
              onClick={handleImageModalClose}
            >
              Submit
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/*update travel notes*/}
      <Modal
        show={showTravelNotes}
        onHide={handleTravelNotesModalClose}
        centered
        dialogClassName="modal-400w"
      >
        <Modal.Header closeButton className="">
          <Modal.Title className="fs-18 fw-bold">Travel Notes</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Formik
            validationSchema={TravelNotesSchema}
            initialValues={{ travel_notes: inspectionData?.travel_notes }}
            onSubmit={(values, actions) => {
              actions.setSubmitting(false);
              travelNotesSubmitForm(values);
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
            }) => (
              <Form className="text-start" noValidate onSubmit={handleSubmit}>
                <InputTextArea
                  controlId="travel_notes"
                  label="Travel Notes"
                  placeholder="Travel Notes"
                  touched={touched.travel_notes}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  errorsField={errors.travel_notes}
                  value={values.travel_notes}
                />

                <div className="d-flex justify-content-end mt-2">
                  <Button
                    variant="outline-secondary"
                    className="me-2 fs-15 fw-semibold text-black"
                    onClick={handleTravelNotesModalClose}
                  >
                    Close
                  </Button>
                  <Button
                    variant="primary"
                    className="fs-15 fw-semibold text-black"
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>

      <Loader isLoading={loading} />
    </>
  );
};
